import Dialog from '@mui/material/Dialog';
import { Box, IconButton, Typography, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

export interface ReportNotABirdSuccessDialogProps {
  open: boolean;
  segment_name: string;
  message?: string;
  onClose: () => void;
}

export function ReportNotABirdSuccessDialog(props: ReportNotABirdSuccessDialogProps): JSX.Element {
  const { onClose, open, message } = props;

  const handleClose = () => {
    onClose();
  };

  // Default message if none provided
  const displayMessage = message || "Thank you for your feedback! The segment has been marked as \"not a bird\" and our team has been notified.";

  return (
    <Dialog
      onClose={handleClose}
      open={open}
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '480px',
            borderRadius: '16px',
            boxShadow: '0px 8px 32px rgba(0, 0, 0, 0.12)',
            border: '1px solid rgba(229, 231, 235, 0.8)',
            background: 'linear-gradient(145deg, #ffffff 0%, #fafafa 100%)',
            overflow: 'hidden',
          },
        },
      }}
    >
      <Box
        sx={{
          position: 'relative',
          padding: '32px',
          textAlign: 'center',
        }}
      >
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: '16px',
            top: '16px',
            color: '#8B8296',
            '&:hover': {
              backgroundColor: 'rgba(139, 130, 150, 0.08)',
            },
          }}
        >
          <CloseIcon />
        </IconButton>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '16px',
          }}
        >
          <Box
            sx={{
              width: '64px',
              height: '64px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #10B981 0%, #059669 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0px 4px 16px rgba(16, 185, 129, 0.3)',
            }}
          >
            <CheckCircleIcon
              sx={{
                fontSize: '32px',
                color: '#ffffff',
              }}
            />
          </Box>

          <Typography
            variant="h5"
            sx={{
              color: '#17052D',
              fontWeight: 600,
              fontSize: '20px',
              lineHeight: '28px',
            }}
          >
            Report Submitted Successfully!
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: '#6B7280',
              fontSize: '14px',
              lineHeight: '20px',
              maxWidth: '320px',
            }}
          >
            {displayMessage}
          </Typography>

          <Button
            variant="contained"
            onClick={handleClose}
            sx={{
              marginTop: '8px',
              borderRadius: '8px',
              padding: '10px 24px',
              fontWeight: 500,
              fontSize: '14px',
              textTransform: 'none',
              background: 'linear-gradient(135deg, #45009C 0%, #7C3AED 100%)',
              boxShadow: '0px 2px 8px rgba(69, 0, 156, 0.25)',
              '&:hover': {
                background: 'linear-gradient(135deg, #7C3AED 0%, #45009C 100%)',
                boxShadow: '0px 4px 12px rgba(69, 0, 156, 0.35)',
                transform: 'translateY(-1px)',
              },
              '&:active': {
                transform: 'translateY(0px)',
              },
            }}
          >
            Got it
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
} 